import { gql } from 'apollo-angular'
import type { DocumentNode } from 'graphql'

export const REMOVE_RESELLER: DocumentNode = gql`
  mutation RemoveReseller($organizationId: Int!) {
    removeReseller(data: { organizationId: $organizationId }) {
      success
    }
  }
`
